import { default as _91cartId_93wggUpa5BpSMeta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/attendance/[id]/confirmation/[cartId].vue?macro=true";
import { default as _91invitationId_93brhTABk5JbMeta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/attendance/[id]/decline-invitation/[invitationId].vue?macro=true";
import { default as confirmationIwMth6FcNcMeta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/attendance/[id]/decline-invitation/confirmation.vue?macro=true";
import { default as donation_45kioskYCpmPBf0pcMeta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/attendance/[id]/donation-kiosk.vue?macro=true";
import { default as _91token_93cOHK9zX3R7Meta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/attendance/[id]/e-tickets/[token].vue?macro=true";
import { default as eventY7yeUGOAqQMeta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/attendance/[id]/event.vue?macro=true";
import { default as express_45checkinkIZZv0ih3FMeta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/attendance/[id]/express-checkin.vue?macro=true";
import { default as link_45expiredpx8nwKDL5oMeta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/attendance/[id]/link-expired.vue?macro=true";
import { default as prepaid_45registrationuC8zecoGCHMeta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/attendance/[id]/prepaid-registration.vue?macro=true";
import { default as registration_45closedQv4wXPxh2hMeta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/attendance/[id]/registration-closed.vue?macro=true";
import { default as registrationGikfRKWWMeMeta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/attendance/[id]/registration.vue?macro=true";
import { default as sponsorhhE7CvL8eaMeta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/attendance/[id]/sponsor.vue?macro=true";
import { default as _91cartId_93R9ruyi2u7LMeta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/checkout/[eventId]/[cartId].vue?macro=true";
import { default as indexpKuCN14i9QMeta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/fundraising/index.vue?macro=true";
import { default as _91cartId_936dWVyhOOmuMeta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/[id]/confirmation/[cartId].vue?macro=true";
import { default as _91invitationId_93mYGOvgWaEWMeta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/[id]/decline-invitation/[invitationId].vue?macro=true";
import { default as confirmationeppiS2zcWlMeta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/[id]/decline-invitation/confirmation.vue?macro=true";
import { default as donation_45kioskTRqFGIshf6Meta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/[id]/donation-kiosk.vue?macro=true";
import { default as eventzWIrSoMI2xMeta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/[id]/event.vue?macro=true";
import { default as _91fundraiser_id_93DkF7X1UjyoMeta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/[id]/fundraiser/[fundraiser_id].vue?macro=true";
import { default as confirmationw0cW9hHWNyMeta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/[id]/invitation/[invitationId]/confirmation.vue?macro=true";
import { default as indexhJEyfx5YCvMeta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/[id]/invitation/[invitationId]/index.vue?macro=true";
import { default as indext9XIikc5Q1Meta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/[id]/invitation/index.vue?macro=true";
import { default as registration_45closedAabTnlpTi4Meta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/[id]/registration-closed.vue?macro=true";
import { default as registrationONllJH3knqMeta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/[id]/registration.vue?macro=true";
import { default as sponsor_45selectionbbbn7Tu2SkMeta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/[id]/sponsor-selection.vue?macro=true";
import { default as ticket_45selectionMYqwtpvexgMeta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/[id]/ticket-selection.vue?macro=true";
import { default as loginqZ1eMA6y1iMeta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/login.vue?macro=true";
import { default as password_45resetQ2InfQyBjnMeta } from "/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/password-reset.vue?macro=true";
export default [
  {
    name: "attendance-id-confirmation-cartId",
    path: "/attendance/:id()/confirmation/:cartId()",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/attendance/[id]/confirmation/[cartId].vue").then(m => m.default || m)
  },
  {
    name: "attendance-id-decline-invitation-invitationId",
    path: "/attendance/:id()/decline-invitation/:invitationId()",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/attendance/[id]/decline-invitation/[invitationId].vue").then(m => m.default || m)
  },
  {
    name: "attendance-id-decline-invitation-confirmation",
    path: "/attendance/:id()/decline-invitation/confirmation",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/attendance/[id]/decline-invitation/confirmation.vue").then(m => m.default || m)
  },
  {
    name: "attendance-id-donation-kiosk",
    path: "/attendance/:id()/donation-kiosk",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/attendance/[id]/donation-kiosk.vue").then(m => m.default || m)
  },
  {
    name: "attendance-id-e-tickets-token",
    path: "/attendance/:id()/e-tickets/:token()",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/attendance/[id]/e-tickets/[token].vue").then(m => m.default || m)
  },
  {
    name: "attendance-id-event",
    path: "/attendance/:id()/event",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/attendance/[id]/event.vue").then(m => m.default || m)
  },
  {
    name: "attendance-id-express-checkin",
    path: "/attendance/:id()/express-checkin",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/attendance/[id]/express-checkin.vue").then(m => m.default || m)
  },
  {
    name: "attendance-id-link-expired",
    path: "/attendance/:id()/link-expired",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/attendance/[id]/link-expired.vue").then(m => m.default || m)
  },
  {
    name: "attendance-id-prepaid-registration",
    path: "/attendance/:id()/prepaid-registration",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/attendance/[id]/prepaid-registration.vue").then(m => m.default || m)
  },
  {
    name: "attendance-id-registration-closed",
    path: "/attendance/:id()/registration-closed",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/attendance/[id]/registration-closed.vue").then(m => m.default || m)
  },
  {
    name: "attendance-id-registration",
    path: "/attendance/:id()/registration",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/attendance/[id]/registration.vue").then(m => m.default || m)
  },
  {
    name: "attendance-id-sponsor",
    path: "/attendance/:id()/sponsor",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/attendance/[id]/sponsor.vue").then(m => m.default || m)
  },
  {
    name: "checkout-eventId-cartId",
    path: "/checkout/:eventId()/:cartId()",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/checkout/[eventId]/[cartId].vue").then(m => m.default || m)
  },
  {
    name: "fundraising",
    path: "/fundraising",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/fundraising/index.vue").then(m => m.default || m)
  },
  {
    name: "peer-id-confirmation-cartId",
    path: "/peer/:id()/confirmation/:cartId()",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/[id]/confirmation/[cartId].vue").then(m => m.default || m)
  },
  {
    name: "peer-id-decline-invitation-invitationId",
    path: "/peer/:id()/decline-invitation/:invitationId()",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/[id]/decline-invitation/[invitationId].vue").then(m => m.default || m)
  },
  {
    name: "peer-id-decline-invitation-confirmation",
    path: "/peer/:id()/decline-invitation/confirmation",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/[id]/decline-invitation/confirmation.vue").then(m => m.default || m)
  },
  {
    name: "peer-id-donation-kiosk",
    path: "/peer/:id()/donation-kiosk",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/[id]/donation-kiosk.vue").then(m => m.default || m)
  },
  {
    name: "peer-id-event",
    path: "/peer/:id()/event",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/[id]/event.vue").then(m => m.default || m)
  },
  {
    name: "peer-id-fundraiser-fundraiser_id",
    path: "/peer/:id()/fundraiser/:fundraiser_id()",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/[id]/fundraiser/[fundraiser_id].vue").then(m => m.default || m)
  },
  {
    name: "peer-id-invitation-invitationId-confirmation",
    path: "/peer/:id()/invitation/:invitationId()/confirmation",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/[id]/invitation/[invitationId]/confirmation.vue").then(m => m.default || m)
  },
  {
    name: "peer-id-invitation-invitationId",
    path: "/peer/:id()/invitation/:invitationId()",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/[id]/invitation/[invitationId]/index.vue").then(m => m.default || m)
  },
  {
    name: "peer-id-invitation",
    path: "/peer/:id()/invitation",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/[id]/invitation/index.vue").then(m => m.default || m)
  },
  {
    name: "peer-id-registration-closed",
    path: "/peer/:id()/registration-closed",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/[id]/registration-closed.vue").then(m => m.default || m)
  },
  {
    name: "peer-id-registration",
    path: "/peer/:id()/registration",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/[id]/registration.vue").then(m => m.default || m)
  },
  {
    name: "peer-id-sponsor-selection",
    path: "/peer/:id()/sponsor-selection",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/[id]/sponsor-selection.vue").then(m => m.default || m)
  },
  {
    name: "peer-id-ticket-selection",
    path: "/peer/:id()/ticket-selection",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/[id]/ticket-selection.vue").then(m => m.default || m)
  },
  {
    name: "peer-login",
    path: "/peer/login",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/login.vue").then(m => m.default || m)
  },
  {
    name: "peer-password-reset",
    path: "/peer/password-reset",
    component: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/pages/peer/password-reset.vue").then(m => m.default || m)
  }
]